<template>
    <div>
        <h4 class="header-title m-0 text-dark">
            <i class="fa-fw ti-marker-alt m-r-10"></i>{{ $t('subscription') }}
        </h4>
        <div v-pml-block="isLoading" style="min-height: 100px;" v-if="tenant.stripeStatus != 'trialing'">
            <hr>
            <div class="row text-center" v-if="subscription.plan_name">
                <div class="col-xs-12 m-b-30">
                    <div class="clearfix t_right">
                        <label :class="`label label-${ labelStatus(subscription.status) }`">{{ $t(subscription.status) }}</label>
                    </div>
                    <h5 class="text-muted m-t-0 font-16">{{ $t('subscription') }}</h5>
                    <h2 class="font-600 m-b-0">R$ {{ subscription.plan_amount }} <small class="text-muted">/ {{ $t('user') }}</small></h2>
                    <div class="row">
                        <div class="col-xs-12 col-sm-4 m-t-30">
                            <h5 class="text-muted font-16">{{ $t('plan') }}</h5>
                            <h5 class="m-b-10">{{ $t(subscription.plan_name) }}</h5>
                            <small class="text-muted show">{{ $t('started_at') }} <b class="text-dark">{{ subscription.start | pmlDateUnix }}</b></small>
                        </div>
                        <div class="col-xs-12 col-sm-4 border_custom_subcribe m-t-30">
                            <h5 class="text-muted font-16">{{ $t('current_period') }}</h5>
                            <h5 class="m-b-10">{{ subscription.current_period_start | pmlDateUnix }} ~ {{ subscription.current_period_end | pmlDateUnix }}</h5>
                            <small class="text-muted show"><b class="text-dark">{{ subscription.quantity }}</b> {{ $t('users') }}</small>
                        </div>
                        <div class="col-xs-12 col-sm-4 m-t-30" v-if="!isCancelled()">
                            <h5 class="text-muted font-16">{{ $t('next_charge') }}</h5>
                            <h5 class="m-b-10">R$ {{ subscription.next_billing_total }}</h5>
                            <small class="text-muted show">{{ $t('on') }} <b class="text-dark">{{ subscription.next_billing_date | pmlDateUnix }}</b></small>
                        </div>
                        <div class="col-xs-12 col-sm-4 m-t-30" v-else>
                            <h5 class="text-muted font-16">{{ $t('canceled') }}</h5>
                            <small class="text-muted show">{{ $t('finishes_at') }} <b class="text-dark">{{ subscription.ends_at | pmlDateUnix }}</b></small>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-7">
                    <a class="btn btn-primary btn-custom btn-rounded m-b-15" href="https://www.pumpmylead.com/politica-de-privacidade" target="_blank"><i class="fa fa-file-text m-r-10"></i> {{ $t('terms_and_conditions_of_use') }}</a>
                </div>
                <div class="col-xs-12 col-sm-5" v-if="!isCancelled()">
                    <button class="btn btn-white btn-custom btn-rounded m-b-15" v-pml-block="isCancelling" @click="askToCancel"><i class="fa fa-ban m-r-10"></i> {{ $t('cancel_subscribe') }}</button>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row text-center" v-if="subscription.plan_name">
                <div class="col-xs-12 m-b-30">
                    <h5 class="text-muted m-t-0 font-16">{{ $t('subscription') }}</h5>
                    <h2 class="font-600 m-b-0">{{ $t('trial') }}</h2>
                    <small class="text-muted show">{{ $t('finishes_at') }} <b class="text-dark">{{ subscription.ends_at | pmlDateUnix }}</b></small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { isNull } from 'lodash'
    import { trans } from 'utils/helpers/translation'
    import { cancel as cancelSubscription, get as getSubscription } from 'services/subscriptions'
    import { cancelAccountWarning, subscriptionCanceled } from 'utils/helpers/sweet-alert'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'Subscription',
        data () {
            return {
                subscription: {},
                isLoading: false,
                isCancelling: false
            }
        },
        mounted () {
            this.fetch()
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            })
        },
        methods: {
            ...mapActions([ 'setTenant' ]),
            fetch () {
                this.isLoading = true

                getSubscription()
                    .then(response => {
                        this.subscription = response.data
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => {
                        this.isLoading = false
                    })
            },
            askToCancel () {
                cancelAccountWarning()
                    .then((response) => (response.value) ? this.cancelAccount() : null)
            },
            cancelAccount () {
                this.isCancelling = true

                cancelSubscription(this.subscription.id)
                    .then(response => {
                        this.setTenant(response.data)
                        subscriptionCanceled()
                    })
                    .catch(error => Notify.error(error.response.data))
                    .then(() => { this.isCancelling = false })
            },
            subscriptionCanceled () {
                subscriptionCanceled()
            },
            labelStatus (status) {
                if (status === 'active')
                    return 'default'

                if (status === 'past_due')
                    return 'warning'

                if (status === 'unpaid')
                    return 'danger'
            },
            isCancelled () {
                return !isNull(this.subscription.ends_at) && isNull(this.subscription.next_billing_date)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/billing/subscriptions/Current.vue